/* Runtime-first config:
   1) window.__ENV (loaded from /env.js, generated at deploy time)
   2) process.env (build-time fallback, useful for local development)
*/
const fromWindow = (typeof window !== "undefined" && window.__ENV) ? window.__ENV : {};

const get = (key, fallback = "") => {
  const value = fromWindow[key];
  if (value !== undefined && value !== null && value !== "") {
    return value;
  }
  const buildValue = (typeof process !== "undefined" && process.env) ? process.env[key] : undefined;
  return (buildValue !== undefined && buildValue !== null && buildValue !== "") ? buildValue : fallback;
};

export const ENV = {
  VUE_APP_ENVIRONMENT: get("VUE_APP_ENVIRONMENT"),
  VUE_APP_API_BASE_URL: get("VUE_APP_API_BASE_URL"),
  VUE_APP_AUTH_TOKEN: get("VUE_APP_AUTH_TOKEN"),
};
